import { Typography } from '@/modules/perseo-billing/ui/react/src/components/beta';

import { GiftCardFeedbacks } from '../feedbacks.component';
import { ModalFindGiftCard } from '../find-gift-card.component';

import { GiftCardForm } from './add-gift-card-form.component';

export const AddGiftCard = () => {
  return (
    <>
      <GiftCardFeedbacks />
      <div className="co-hidden lg:co-flex co-mb-16px">
        <Typography size="h4">Ingresa los datos de tu tarjeta.</Typography>
      </div>
      <GiftCardForm />
      <ModalFindGiftCard />
    </>
  );
};
